export default "__VITE_ASSET__b984a03c__"